/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedBarcodeTypeRequest
 */
export interface APIPatchedBarcodeTypeRequest {
    /**
     * 
     * @type {string}
     * @memberof APIPatchedBarcodeTypeRequest
     */
    name?: string;
}

/**
 * Check if a given object implements the APIPatchedBarcodeTypeRequest interface.
 */
export function instanceOfAPIPatchedBarcodeTypeRequest(value: object): value is APIPatchedBarcodeTypeRequest {
    return true;
}

export function APIPatchedBarcodeTypeRequestFromJSON(json: any): APIPatchedBarcodeTypeRequest {
    return APIPatchedBarcodeTypeRequestFromJSONTyped(json, false);
}

export function APIPatchedBarcodeTypeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedBarcodeTypeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function APIPatchedBarcodeTypeRequestToJSON(value?: APIPatchedBarcodeTypeRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
    };
}

